<div class="mb-3">
  <label *ngIf="hasLabel" class="form-label" [attr.for]="label">
    {{ label | translate }}<span *ngIf="required"> * </span>
  </label>

  <ng-container *ngIf="!disabled">
    <ng-select
      [items]="sortedOptions"
      bindLabel="label"
      bindValue="value"
      [multiple]="multiple"
      [formControl]="field"
      [clearable]="hasDeselectOption"
      [searchable]="true"
      [placeholder]="'label.please-select' | translate"
      [notFoundText]="'label.no-items-found' | translate"
      [closeOnSelect]="!multiple"
      (change)="selectionChange.emit($event)"
      [attr.id]="resolvedInputId"
      #autoFocusInput
    >
      <!-- Wenn localizeDate verwendet werden soll -->
      <ng-template ng-label-tmp let-item="item">
        {{ localizeDate ? (item.label | localizedDate) : (item.label | translate) }}
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        {{ localizeDate ? (item.label | localizedDate) : (item.label | translate) }}
      </ng-template>
    </ng-select>
  </ng-container>

  <ng-container *ngIf="disabled">
    <input
      class="form-control"
      [value]="field.value"
      readonly
      disabled
      id="{{ label }}"
    />
  </ng-container>

  <div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
  <div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
</div>
